export const CURRENCY_SEQUENCE_REGEX = /(\d[\d\s]*)([\w.]+\s?)?(тыс\.?|млн\.?|млрд\.?|руб\.?|рубль|рубля|рублей|₽)/gi;

/**
 * Функция, которая заменяет обычные пробелы в числовых и валютных последовательностях на неразрывные пробелы.
 * @param text исходный текст
 * @returns измененный текст
 */
export const formatTextWithNumbers = (text: string | undefined) => {
    if (!text) {
        return '';
    }

    return text.replace(CURRENCY_SEQUENCE_REGEX, numberString => numberString.replace(/\s/g, '&nbsp;'));
};